import '~/sass/pages/test-drive-inquire.scss';
import TestDriveSearch from '@/components/module/TestDriveSearch';

const { $ } = window;

$(() => {
  // eslint-disable-next-line no-unused-vars
  const testDriveSearch = new TestDriveSearch();
});
